import {get, post} from '../../request/http'

// 获取排行榜
export const getRankApi = p => get('/api/festivalActivity/rank', p);
// 获取排行榜
export const getMyRankApi = p => get('/api/festivalActivity/myRank', p);
// 获取抽奖活动信息
export const getActivityInfoApi = p => post('/api/festivalActivity/info', p);
// 获取抽奖活动信息
export const getLotteryNumApi = p => post('/api/festivalActivity/getLotteryNum', p);
// 抽奖接口
export const lotteryApi = p => post('/api/festivalActivity/lottery', p);
// 领取实物奖励
export const underPrizeReceiveApi = p => post('/api/festivalActivity/underPrizeReceive', p);
// 弹窗登录
export const smsDirectLoginApi = p => post('/api/smsDirectLogin', p);

// 获取底部视频信息
export const getRadioUrlApi = p => get('/api/festivalActivity/getRadioUrl', p);
// 获取活动实时状态
export const getActiveStatusApi = p => get('/api/festivalActivity/status', p);

